"use server"

import { cookies } from "next/headers"

import { defaultLocale, isLocale } from "@/i18n/request"

export async function setLocale(locale: string) {
  const value = isLocale(locale) ? locale : defaultLocale
  const cookieStore = await cookies()
  cookieStore.set("NEXT_LOCALE", value, {
    path: "/",
    maxAge: 60 * 60 * 24 * 365,
    sameSite: "lax",
  })
}
